import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CreateTipoTramiteDependenciaRequest, IGetTipoTramitesByDependencia } from '../../shared/interfaces/database/configuracion';


@Injectable({
  providedIn: 'root'
})
export class TipoTramiteDependenciaService {
  private readonly baseUrl = `${environment.apiUrl}/api/tipo_tramite_dependencia`;

  constructor(private http: HttpClient) { }

  getTipoTramitesByDependencias(dependenciaId: number): Observable<IGetTipoTramitesByDependencia[]> {
    return this.http.get<IGetTipoTramitesByDependencia[]>(`${this.baseUrl}/${dependenciaId}`);
  }

  addTipoTramiteToDependencia(request: CreateTipoTramiteDependenciaRequest): Observable<string> {
    return this.http.post(`${this.baseUrl}`, request, { responseType: 'text' });
  }

  deleteTramiteFromDependencia(dependenciaId: number, tipoTramiteId: number): Observable<string> {
    return this.http.delete(`${this.baseUrl}/${dependenciaId}/${tipoTramiteId}`, { responseType: 'text' });
  }

}
